const PRODUCTS = {
  productattribute: 'Product Attribute|Product Attributes',
  productgroup: 'Product Group|Product Groups',
  product: 'Product|Products',
};

export default PRODUCTS;
